var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundAssets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 970.835,
    height: 996.138,
    viewBox: "0 0 970.835 996.138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.794,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#10ffa3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1,
    x2: 0.317,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff00ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa457"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1.21,
    y1: 0.147,
    x2: 0.135,
    y2: 0.7,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8000ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0058ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6c00"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bkg-assets",
    transform: "translate(59.209 -149.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "elm-3",
    d: "M20.8,15.353l-7.48,13.465H28.279L20.8,15.353m0-14.293a4.626,4.626,0,0,1,4.084,2.4L40.3,31.221a4.672,4.672,0,0,1-4.084,6.942H5.377a4.672,4.672,0,0,1-4.084-6.942L16.714,3.462A4.626,4.626,0,0,1,20.8,1.059Z",
    transform: "matrix(0.891, 0.454, -0.454, 0.891, 875.666, 283.719)",
    fill: "#5a6dff",
    opacity: 0.239
  }), /*#__PURE__*/React.createElement("g", {
    id: "elm-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ico-colors",
    d: "M20.342,42.136,62.209.269l41.867,41.867a59.209,59.209,0,1,1-83.734,0ZM62.209,18.877,29.646,51.44A45.908,45.908,0,0,0,16.158,84h92.1A45.907,45.907,0,0,0,94.772,51.44Z",
    transform: "translate(-62.209 149.593)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "elm-5",
    d: "M97.253,1l94.753,54.857V165.571L97.253,220.428,2.5,165.571V55.857ZM32.361,61.619,97.254,99.188l64.892-37.569L97.253,24.05ZM22.448,78.93v75.14L87.28,191.6v-75.14ZM107.228,191.6l64.83-37.533V78.93l-64.83,37.533Z",
    transform: "translate(119.5 925.572)",
    opacity: 0.201,
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "elm-4",
    d: "M33.245,80.339h5.028V55.858h9.792V80.339h5.028c.646-5.883,3.649-10.74,8.523-16.047.549-.6,4.07-4.241,4.487-4.762a29.377,29.377,0,1,0-45.875-.008c.418.522,3.947,4.175,4.489,4.766C29.6,69.6,32.6,74.456,33.245,80.339Zm.132,9.792v4.9H52.962v-4.9ZM12.588,65.647a39.17,39.17,0,1,1,61.155.011c-3.037,3.787-10.989,9.786-10.989,17.13V95.028a9.792,9.792,0,0,1-9.792,9.792H33.377a9.792,9.792,0,0,1-9.792-9.792V82.787C23.585,75.443,15.626,69.438,12.588,65.647Z",
    transform: "translate(528.5 722.888)",
    opacity: 0.7,
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "elm-1-2",
    "data-name": "elm-1",
    d: "M0,29A29,29,0,1,1,29,58,29,29,0,0,1,0,29Zm6.448,0A22.555,22.555,0,1,0,29,6.444,22.582,22.582,0,0,0,6.448,29ZM25.472,48.007l-.006,0L43.7,16.428a19.484,19.484,0,0,1,2.645,4.013L30.262,48.287c-.42.033-.841.044-1.262.044A19.513,19.513,0,0,1,25.472,48.007ZM48.1,25.989a19.454,19.454,0,0,1,.231,2.8v.391A19.339,19.339,0,0,1,35.96,47.035l-.014,0ZM19.335,45.736a18.616,18.616,0,0,1-1.8-1.178L36.75,11.284a19.03,19.03,0,0,1,3.72,2.146L21.258,46.7A19.275,19.275,0,0,1,19.335,45.736Zm-7.67-8.177L27.742,9.706c.368-.027.736-.038,1.105-.041h.31a19.6,19.6,0,0,1,3.384.319L14.3,41.562A19.418,19.418,0,0,1,11.665,37.558Zm-2-8.359v-.388A19.338,19.338,0,0,1,22.052,10.953L9.9,32A19.445,19.445,0,0,1,9.669,29.2Z",
    transform: "translate(378 221)",
    opacity: 0.456,
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundAssets);
export default __webpack_public_path__ + "static/media/background-assets.4d516be761efcfd387bfa1b4d9ef2158.svg";
export { ForwardRef as ReactComponent };